<template>
    <section>
        <div class="row">
            <div class="col s12">
                <div class="card-panel">
                    <div class="row">
                        <h5 class="col s12">Filtros</h5>

                        <div class="input-field col s4">
                            <select ref="sel_edital_pesq"
                                    name="sel_edital_pesq"
                                    id="sel_edital_pesq"
                                    class="materialize-select"
                                    v-model.number="filtro.edital_selecionado"
                                    tipo="materialize">
                                <option value="0">Todos</option>
                                <option v-for="(edital, edital_i) in editais"
                                        :key="edital_i"
                                        :title="edital.ano"
                                        :value="edital.id">{{ edital.ano }}</option>
                            </select>
                            <label for="sel_edital_pesq">Edital</label>
                        </div>

                        <div class="input-field col s4">
                            <select ref="sel_modalidade_pesq"
                                    name="sel_modalidade_pesq"
                                    id="sel_modalidade_pesq"
                                    class="materialize-select"
                                    v-model="filtro.modalidade_acao"
                                    tipo="materialize">
                                <option value="todas">Todas</option>
                                <option value="Programa">Programa</option>
                                <option value="Projeto">Projeto</option>
                                <option value="Evento">Evento</option>
                                <option value="Curso">Curso</option>
                            </select>
                            <label for="sel_modalidade_pesq">Modalidade</label>
                        </div>

                        <div class="input-field col s4">
                            <select ref="sel_coordenador_pesq"
                                    name="sel_coordenador_pesq"
                                    id="sel_coordenador_pesq"
                                    class="materialize-select"
                                    v-model.number="filtro.coordenador_selecionado"
                                    tipo="materialize">
                                <option value="0">Todos</option>
                                <option v-for="(usuario, usuario_i) in usuariosComInscricoesNoSistema"
                                        :key="usuario_i"
                                        :title="usuario.name"
                                        :value="usuario.id">{{ usuario.name }}</option>
                            </select>
                            <label for="sel_coordenador_pesq">Coordenador</label>
                        </div>

                        <div class="input-field col s4">
                            <input type="text" id="txt_nome_acao"
                                   v-model="filtro.nome_acao"
                                   placeholder="Opcional...">
                            <label for="txt_nome_acao">Nome da ação</label>
                        </div>

                        <div class="input-field col s4">
                            <input type="text" id="txt_centro_acao"
                                   v-model="filtro.centro_acao"
                                   placeholder="Opcional...">
                            <label for="txt_centro_acao">Centro da ação</label>
                        </div>

                        <div class="input-field col s4">
                            <input type="text" id="txt_unidade_acao"
                                   v-model="filtro.unidade_acao"
                                   placeholder="Opcional...">
                            <label for="txt_unidade_acao">Unidade da ação</label>
                        </div>

                        <div class="col s12">
                            <div class="row">
                                <div class="col s12 m6">
                                    <div class="card">
                                        <div class="card-content">
                                            <span class="card-title">Selecione os status da análise técnica</span>

                                            <p>
                                                <label>
                                                    <input tipo="materialize"  name="filtro_status_at"
                                                           class="with-gap"
                                                           type="radio"
                                                           id="rdTodos"
                                                           value="todos"
                                                           v-model="filtro.status_analise_tecnica" />
                                                    <span>Todos os status</span>
                                                </label>
                                            </p>

                                            <p>
                                                <label>
                                                    <input tipo="materialize"  name="filtro_status_at"
                                                           class="with-gap"
                                                           type="radio"
                                                           id="rdNaoRealizado"
                                                           value="nao_realizado"
                                                           v-model="filtro.status_analise_tecnica" />
                                                    <span>Não realizado</span>
                                                </label>
                                            </p>

                                            <p>
                                                <label>
                                                    <input tipo="materialize"  name="filtro_status_at"
                                                           class="with-gap"
                                                           type="radio"
                                                           id="rdEmExigencia"
                                                           value="em_exigencia"
                                                           v-model="filtro.status_analise_tecnica" />
                                                    <span>Em exigência</span>
                                                </label>
                                            </p>

                                            <p>
                                                <label>
                                                    <input tipo="materialize"  name="filtro_status_at"
                                                           class="with-gap"
                                                           type="radio"
                                                           id="rdEliminado"
                                                           value="eliminado"
                                                           v-model="filtro.status_analise_tecnica" />

                                                    <span>Eliminado</span>
                                                </label>
                                            </p>

                                            <p>
                                                <label>
                                                    <input tipo="materialize"  name="filtro_status_at"
                                                           class="with-gap"
                                                           type="radio"
                                                           id="rdHabilitado"
                                                           value="habilitado"
                                                           v-model="filtro.status_analise_tecnica" />

                                                    <span>Habilitado</span>
                                                </label>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col s12">
                            <a @click.prevent="obtemListaDeInscricoes"
                               class="btn-small waves-effect waves-light blue lighten-1">Buscar</a>

                            <a @click.prevent="resetFiltros"
                               class="btn-small waves-effect waves-light grey darken-1">Reset</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col s12">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col s12">
                                <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="false"></loading>

                                <section v-if="!loading">
                                    <section v-if="inscricoes.length === 0">
                                        <div class="row">
                                            <div class="col s12">
                                                <p class="label-info-nao-encontrada">Não foram encontradas inscrições cadastradas para os filtros informados.</p>
                                            </div>
                                        </div>
                                    </section>

                                    <section v-else>
                                        <div class="row">
                                            <div class="col s12 m12 l12 xl12">
                                                <table class="responsive-table striped">
                                                    <thead>
                                                    <tr>

                                                        <th>
                                                            <span>Ação</span>
                                                        </th>
                                                        <th>
                                                            <span>Coordenador</span>
                                                        </th>
                                                        <th>
                                                            <span>Modalidade</span>
                                                        </th>
                                                        <th>
                                                            <span>Centro / Unidade</span>
                                                        </th>
                                                        <th>
                                                            <span>Resultado</span>
                                                        </th>
                                                        <th>
                                                            <span>
                                                                Ações
                                                            </span>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(inscricao, i) in inscricoes" :key="i" style="font-size: small;">

                                                        <td>
                                                            <p>
                                                                <span class="tooltipped"
                                                                      :data-tooltip="inscricao.acao"
                                                                      data-position="bottom">{{ truncarTexto(inscricao.acao, 30) }}</span>
                                                            </p>

                                                            <p v-if="inscricao.reenvio_cumprimento_analise_tecnica">
                                                                <br>
                                                                <span class="label-info-baixo-destaque">Ação corrigida e reenviada pelo coordenador em {{ inscricao.reenvio_cumprimento_analise_tecnica }}.</span>
                                                            </p>
                                                        </td>

                                                        <td>
                                                            <span class="tooltipped" :data-tooltip="inscricao.coordenador" data-position="bottom">
                                                                {{ truncarTexto(inscricao.coordenador, 20) }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span>
                                                                {{ inscricao.modalidade }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span class="tooltipped" :data-tooltip="inscricao.centro + ' / ' + inscricao.unidade" data-position="bottom">
                                                                {{ truncarTexto(inscricao.centro + ' / ' + inscricao.unidade, 35) }}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <section v-if="inscricao.tem_analise_tecnica">
                                                                <p>
                                                                    <span :class="retornaCssBadgeDeAcordoComResultadoAnalise(inscricao.resultado_analise)"
                                                                          data-badge-caption="">
                                                                    {{ inscricao.resultado_analise }}</span>
                                                                </p>

                                                                <br>

                                                                <p>
                                                                    <a class="blue-text"
                                                                       style="cursor: pointer;"
                                                                       @click="verAnalistas(inscricao)">Ver analistas</a>
                                                                </p>
                                                            </section>

                                                            <p v-else>
                                                                <span class="label-info-nao-encontrada">Não foi realizada análise técnica</span>
                                                            </p>
                                                        </td>


                                                        <td>
                                                            <p v-if="!inscricao.tem_analise_tecnica && !inscricao.esta_em_periodo_de_nova_analise_tecnica">
                                                                <span class="label-info-nao-encontrada">Não foi realizada análise técnica e nem está em período de análise.</span>
                                                            </p>

                                                            <a v-else-if="!inscricao.tem_analise_tecnica && inscricao.esta_em_periodo_de_nova_analise_tecnica"
                                                               :disabled="inscricao.usuario_e_coordenador_da_acao"
                                                               class="btn-floating btn-small indigo tooltipped"
                                                               style="pointer-events: auto !important;"
                                                               :href="pCreateRoute.replace('inscricaoId', inscricao.id)"
                                                               data-position="left"
                                                               :data-tooltip="inscricao.usuario_e_coordenador_da_acao ? 'Você não pode analisar a própria ação!' : 'Cadastrar análise'">
                                                                <i class="material-icons white-text">add</i>
                                                            </a>

                                                            <div v-else style="display: contents;">
                                                                <a :disabled="!retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada(inscricao)"
                                                                   class="btn-floating btn-small grey darken-4 tooltipped"
                                                                   style="pointer-events: auto !important;"
                                                                   :href="retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada(inscricao) ? pEditRoute.replace('inscricaoId', inscricao.id) : null"
                                                                   data-position="left"
                                                                   :data-tooltip="inscricao.usuario_e_coordenador_da_acao ? 'Você não pode analisar a própria ação!' : 'Editar análise'">
                                                                    <i class="material-icons white-text">edit</i>
                                                                </a>

                                                                &nbsp;
                                                            </div>

                                                            <a v-if="inscricao.tem_analise_tecnica"
                                                               class="btn-floating btn-small blue lighten-1" :href="pShowRoute.replace('inscricaoId', inscricao.id)"
                                                               title="Visualizar análise">
                                                                <i class="material-icons white-text">visibility</i>
                                                            </a>

                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                </section>

                            </div>
                        </div>
                    </div>
                    <div class="card-action">
                        <div class="row">
                            <div class="col s12">
                                <div class="left">
                                    <strong>Total de registros por pagina</strong>
                                    <select name="total_regs_pag"
                                            class="browser-default"
                                            style="width: auto;"
                                            id="total_regs_pag"
                                            @change="obtemListaDeInscricoes"
                                            v-model="paginacao.regsPorPage">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                    </select>
                                </div>

                                <div class="center">
                                    <vuepaginate :totalPage="paginacao.totalPages"
                                                 v-model="paginacao.currentPage"
                                                 nextText="Próximo"
                                                 prevText="Anterior"
                                                 :withNextPrev="true"
                                                 :customActiveBGColor="'#000099'"
                                                 @btnClick="mudaPagina"></vuepaginate>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import vuepaginate from "../utils/vuepaginate";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as swalMsg from "../utils/swalMsg";

export default {
    name: "analises-tecnicas",
    components: {
        vuepaginate,
        Loading,
    },
    props: {
        pEditais: {
            type: String,
            default: null
        },
        pTemEditalAberto: {
            type: String,
            default: null
        },
        pUsuariosComInscricoesNoSistema: {
            type: String,
            default: null
        },
        pCreateRoute: {
            type: String,
            default: null
        },
        pEditRoute: {
            type: String,
            default: null
        },
        pShowRoute: {
            type: String,
            default: null
        },
        successMsg: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            //Váriaveis de Paginação
            paginacao: {
                regsPorPage: 5,
                totalPages: 1,
                totalRegs: 0,
                currentPage: 1,
            },

            //Filtros
            filtro: {
                termo_pesquisa: null,
                edital_selecionado: 0,
                nome_acao: null,
                modalidade_acao: 'todas',
                centro_acao: null,
                unidade_acao: null,
                coordenador_selecionado: 0,
                status_analise_tecnica: 'todos',
            },

            //Dados da tela e controle do formulário
            loading: false,
            temEditalAberto: !this.pTemEditalAberto ? false : (/true|1|"1"/i).test(JSON.parse(this.pTemEditalAberto)),
            editais: !this.pEditais ? [] : JSON.parse(this.pEditais),
            usuariosComInscricoesNoSistema: !this.pUsuariosComInscricoesNoSistema ? [] : JSON.parse(this.pUsuariosComInscricoesNoSistema),
            inscricoes: []
        }
    },
    methods: {
        //Método de paginação
        mudaPagina: function(page){
            this.paginacao.currentPage = page
            this.obtemListaDeInscricoes()
        },

        //Métodos de consulta de dados
        async obtemListaDeInscricoes(){
            const editalSelecionado = this.filtro.edital_selecionado === '' ? null : this.filtro.edital_selecionado
            const modalidadeAcao = this.filtro.modalidade_acao === '' ? null : this.filtro.modalidade_acao
            const centroAcao = this.filtro.centro_acao === '' ? null : this.filtro.centro_acao
            const unidadeAcao = this.filtro.unidade_acao === '' ? null : this.filtro.unidade_acao
            const coordenadorSelecionado = this.filtro.coordenador_selecionado === '' ? null : this.filtro.coordenador_selecionado
            const nomeAcao = this.filtro.nome_acao === '' ? null : this.filtro.nome_acao
            const statusAt = this.filtro.status_analise_tecnica === '' || this.filtro.status_analise_tecnica === null ? 'todos' : this.filtro.status_analise_tecnica
            const paginaAtual = this.paginacao.currentPage === '' ? 1 : this.paginacao.currentPage
            const registrosPorPagina = this.paginacao.regsPorPage === '' ? 5 : this.paginacao.regsPorPage

            const url = `/api/analises-tecnicas/lista/inscricoes/${editalSelecionado}/${modalidadeAcao}/${centroAcao}/${unidadeAcao}/${coordenadorSelecionado}/${nomeAcao}/${statusAt}/${paginaAtual}/${registrosPorPagina}`


            try {
                this.loading = true

                await this.$http.get(url).then(response => {
                    this.paginacao.totalPages = parseInt(response.body.totalDePaginas)
                    this.paginacao.currentPage = parseInt(response.body.paginaAtual)
                    this.paginacao.totalRegs = parseInt(response.body.totalDeRegistros)
                    this.inscricoes = response.body.inscricoes
                }, error => {
                    Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'})
                })
            }catch (e) {
                Swal.fire({ title: 'Desculpe! Ocorreu um erro.', text: 'Ocorreu um erro inesperado!', footer: e.message, icon: 'error'})
            }finally {
                this.loading = false
            }

            this.loading = false
        },

        resetFiltros() {
            this.filtro.termo_pesquisa = null
            this.filtro.edital_selecionado = this.editais[0].id
            this.filtro.nome_acao = null
            this.filtro.modalidade_acao = 'todas'
            this.filtro.centro_acao = null
            this.filtro.unidade_acao = null
            this.filtro.coordenador_selecionado = 0

            this.obtemListaDeInscricoes()
        },

        selecionaUltimoEdital(){
            this.filtro.edital_selecionado = this.editais[0].id
        },

        truncarTexto(texto, caracteres = 10){
            return _.truncate(texto, {
                'omission': ' [...]',
                'length': caracteres,
            })
        },

        retornaCssBadgeDeAcordoComResultadoAnalise(resultado)
        {
            const spanBadge = 'new badge '

            if(resultado === 'HABILITADO')
                return spanBadge + 'green';
            if(resultado === 'EXIGÊNCIA')
                return spanBadge + 'amber darken-3';
            if(resultado === 'ELIMINADO')
                return spanBadge + 'red';
        },

        retornaSeInscricaoEstaHabilitadaParaTerAnaliseTecnicaEditada(inscricao){
            return (!inscricao.usuario_e_coordenador_da_acao && inscricao.esta_em_periodo_de_analise)
        },

        verAnalistas(inscricao){
            let htmlResult = null

            _.forEach(inscricao.analistas, (analista) => {
                let htmlText = '<p><strong>' + analista.nome + ' </strong></p> <p><span>Última atualização: ' + analista.ultima_atualizacao + '</span></p>'

                htmlResult = htmlResult != null ? htmlResult + htmlText : htmlText

            })

            Swal.fire({
                title: 'Analistas que trabalharam na análise.',
                html: htmlResult,
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                }
            })
        }

    },
    mounted() {
        if(this.successMsg)
            swalMsg.toastMsg('top-center', 'success', this.successMsg)

        this.selecionaUltimoEdital()

        this.resetFiltros()

        this.obtemListaDeInscricoes()

    },
    updated() {
        $('.tooltipped').tooltip();
        $('#sel_edital_pesq').formSelect()
        $('#sel_modalidade_pesq').formSelect()
        $('#sel_coordenador_pesq').formSelect()
    }
}
</script>

<style scoped>

</style>
